import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
interface Purchase {
  id: string;
  name: string;
  location: string;
  timeAgo: string;
}
const people = [{
  name: 'Laura',
  location: 'Medellín, Colombia'
}, {
  name: 'Camila',
  location: 'Bogotá, Colombia'
}, {
  name: 'Valentina',
  location: 'Santiago, Chile'
}, {
  name: 'Carlos',
  location: 'Ciudad de México, México'
}, {
  name: 'Daniela',
  location: 'Lima, Perú'
}, {
  name: 'Lucía',
  location: 'Madrid, España'
}, {
  name: 'Javier',
  location: 'Barcelona, España'
}, {
  name: 'Martín',
  location: 'Córdoba, Argentina'
}, {
  name: 'Paula',
  location: 'Valencia, España'
}, {
  name: 'Camila',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Andrés',
  location: 'Quito, Ecuador'
}, {
  name: 'Sofía',
  location: 'Guadalajara, México'
}];
const timeAgoOptions = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos', 'hace 20 minutos'];
function generateRandomPurchase(): Purchase {
  const person = people[Math.floor(Math.random() * people.length)];
  const timeAgo = timeAgoOptions[Math.floor(Math.random() * timeAgoOptions.length)];
  return {
    id: Math.random().toString(36).slice(2, 11),
    name: person.name,
    location: person.location,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const timeouts = useRef<number[]>([]);
  useEffect(() => {
    const schedule = (delay: number) => {
      const id = window.setTimeout(() => {
        setCurrentPurchase(generateRandomPurchase());
        const hideId = window.setTimeout(() => {
          setCurrentPurchase(null);
          // Random interval between 12 and 15 seconds for a natural rhythm
          schedule(12000 + Math.random() * 3000);
        }, 4500);
        timeouts.current.push(hideId);
      }, delay);
      timeouts.current.push(id);
    };
    schedule(5000);
    return () => {
      timeouts.current.forEach(id => window.clearTimeout(id));
      timeouts.current = [];
    };
  }, []);
  return <AnimatePresence data-id="element-149" data-mp="1vt4q1rqyevhs">
      {currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 24,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 right-3 sm:left-auto sm:bottom-6 sm:right-6 z-40 sm:max-w-xs" data-id="element-150" data-mp="1vuzaz6286nlv">
          <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-xl border border-stone-200 px-3 py-2.5 flex items-center gap-2.5" data-id="element-151" data-mp="ke7zuej1a08u">
            <div className="flex-shrink-0 w-7 h-7 bg-teal-600 rounded-full flex items-center justify-center" data-id="element-152" data-mp="cvrydpl82x3i">
              <CheckCircle2 className="w-4 h-4 text-white" data-id="element-153" data-mp="838cm5cdsvnm" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-154" data-mp="3445dk90p7zx">
              <p className="font-semibold text-stone-900 text-xs truncate" data-id="element-155" data-mp="32t0ti7qzw7r">
                {currentPurchase.name} · {currentPurchase.location}
              </p>
              <p className="text-stone-500 text-[11px] mt-0.5" data-id="element-156" data-mp="vsjg3ul4945g">
                Obtuvo Orden Financiero™ {currentPurchase.timeAgo}
              </p>
            </div>

            <button onClick={() => setCurrentPurchase(null)} className="flex-shrink-0 text-stone-400 hover:text-stone-600 transition-colors" aria-label="Cerrar notificación" data-id="element-157" data-mp="lv517zeucnf9">
              <X className="w-3.5 h-3.5" data-id="element-158" data-mp="36mowpejs9f68" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}